import Validation from "@irati/utils/validation";
export var customRewardNameSchema = function (intl, maxChars) {
    return Validation.string("platform.defaultValidation.required")
        .test("notJustSpaces", "platform.defaultValidation.notJustSpaces", function (value) { return value && value.trim().length !== 0; })
        .max(maxChars, intl.formatMessage({ id: "platform.defaultValidation.maxLength" }, { count: intl.formatNumber(maxChars) }));
};
